import { useContext } from 'react';
import { useUI } from '@/hooks/redux';
import { DashboardContext } from '@/contexts/DashboardContext';
import { cn } from '@/utils';

export default function Loader({ overlay = false }: { overlay?: boolean }) {
  const { sidebarOpen } = useUI();
  const isDashboard = useContext(DashboardContext);

  if (overlay) {
    return (
      <div
        className={cn(
          'absolute inset-y-0 right-0 left-0 z-50 flex items-center justify-center transition-all duration-300 backdrop-blur-sm bg-white/50',
          isDashboard ? (sidebarOpen ? 'lg:left-80' : 'lg:left-16') : ''
        )}
      >
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="w-full flex items-center justify-center min-h-[200px] py-8">
      <div className="loader"></div>
    </div>
  );
}
